import Immutable from 'immutable';
import { RootStateOrAny } from 'react-redux';
import { AnyAction } from 'redux';
import { VideoLecture } from '../../domain/entities/';

import {
  FETCH_RECOMMENDED_VIDEOS_REQUEST,
  FETCH_RECOMMENDED_VIDEOS_FAILURE,
  FETCH_RECOMMENDED_VIDEOS_SUCCESS,
  FETCH_RECOMMENDED_VIDEO_BY_ID_REQUEST,
  FETCH_RECOMMENDED_VIDEO_BY_ID_SUCCESS,
  FETCH_RECOMMENDED_VIDEO_BY_ID_FAILURE,
  FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST,
  FETCH_VIDEO_BY_ID_FROM_CONTENT_SUCCESS,
  FETCH_VIDEO_BY_ID_FROM_CONTENT_FAILURE,
  SET_RECOMMENDED_VIDEOS,
  SET_VIDEO_DATA,
  FETCH_LAST_BOUGHT_VIDEOS_FAILURE,
  FETCH_LAST_BOUGHT_VIDEOS_REQUEST,
  FETCH_LAST_BOUGHT_VIDEOS_SUCCESS,
  SET_LAST_BOUGHT_VIDEOS,
  FETCH_VIDEOS_FAILURE,
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
} from './actionType';

export const initialState = {
  recommendedVideos: [],
  recentlyBought: [],
  videos: {},
  requests: {},
};

export type VideoLectureStore = typeof initialState;

export default (
  state: RootStateOrAny = initialState,
  action: AnyAction,
): object => {
  const { payload, type } = action;

  switch (type) {
    case SET_VIDEO_DATA:
      return Immutable.fromJS(state)
        .updateIn(['videos'], () => payload)
        .toJS();
    case SET_RECOMMENDED_VIDEOS:
      return Immutable.fromJS(state)
        .updateIn(['recommendedVideos'], () => payload)
        .toJS();
    case SET_LAST_BOUGHT_VIDEOS:
      return Immutable.fromJS(state)
        .updateIn(['recentlyBought'], () => payload)
        .toJS();
    case FETCH_RECOMMENDED_VIDEOS_REQUEST:
      return Immutable.fromJS(state)
        .updateIn(
          ['requests', FETCH_RECOMMENDED_VIDEOS_REQUEST, 'pending'],
          () => true,
        )
        .toJS();
    case FETCH_RECOMMENDED_VIDEOS_SUCCESS:
      return Immutable.fromJS(state)
        .updateIn(
          ['successfulRequests', FETCH_RECOMMENDED_VIDEOS_REQUEST],
          () => payload.response,
        )
        .updateIn(
          ['requests', FETCH_RECOMMENDED_VIDEOS_REQUEST, 'pending'],
          () => false,
        )
        .toJS();
    case FETCH_RECOMMENDED_VIDEOS_FAILURE:
      return Immutable.fromJS(state)
        .updateIn(
          ['failedRequests', FETCH_RECOMMENDED_VIDEOS_REQUEST],
          () => payload.error,
        )
        .updateIn(
          ['requests', FETCH_RECOMMENDED_VIDEOS_REQUEST, 'pending'],
          () => false,
        )
        .toJS();
    case FETCH_RECOMMENDED_VIDEO_BY_ID_REQUEST:
      return Immutable.fromJS(state)
        .updateIn(
          ['requests', FETCH_RECOMMENDED_VIDEO_BY_ID_REQUEST, 'pending'],
          () => true,
        )
        .toJS();
    case FETCH_RECOMMENDED_VIDEO_BY_ID_SUCCESS:
      return Immutable.fromJS(state)
        .updateIn(
          ['successfulRequests', FETCH_RECOMMENDED_VIDEO_BY_ID_REQUEST],
          () => payload.response,
        )
        .updateIn(
          ['requests', FETCH_RECOMMENDED_VIDEO_BY_ID_REQUEST, 'pending'],
          () => false,
        )
        .updateIn(['recommendedVideos'], () => {
          const recVideos = state.recommendedVideos as VideoLecture[];
          const fetchedRecVideo = [] as VideoLecture[];
          fetchedRecVideo.push(payload.response);
          return recVideos.map(
            recVideo =>
              fetchedRecVideo.find(fetched => fetched.id === recVideo.id) ||
              recVideo,
          );
        })
        .toJS();
    case FETCH_RECOMMENDED_VIDEO_BY_ID_FAILURE:
      return Immutable.fromJS(state)
        .updateIn(
          ['failedRequests', FETCH_RECOMMENDED_VIDEO_BY_ID_REQUEST],
          () => payload.error,
        )
        .updateIn(
          ['requests', FETCH_RECOMMENDED_VIDEOS_REQUEST, 'pending'],
          () => false,
        )
        .toJS();
    case FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST:
      return Immutable.fromJS(state)
        .updateIn(
          ['requests', FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST, 'pending'],
          () => true,
        )
        .toJS();
    case FETCH_VIDEO_BY_ID_FROM_CONTENT_SUCCESS:
      return Immutable.fromJS(state)
        .updateIn(
          ['successfulRequests', FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST],
          () => payload.response,
        )
        .updateIn(['videos'], () => {
          return {
            ...state.videos,
            [`${payload.response.id}`]: payload.response,
          };
        })
        .updateIn(
          ['requests', FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST, 'pending'],
          () => false,
        )
        .toJS();
    case FETCH_VIDEO_BY_ID_FROM_CONTENT_FAILURE:
      return Immutable.fromJS(state)
        .updateIn(
          ['failedRequests', FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST],
          () => payload.error,
        )
        .updateIn(
          ['requests', FETCH_VIDEO_BY_ID_FROM_CONTENT_REQUEST, 'pending'],
          () => false,
        )
        .toJS();
    case FETCH_LAST_BOUGHT_VIDEOS_SUCCESS:
      return Immutable.fromJS(state)
        .updateIn(
          ['successfulRequests', FETCH_LAST_BOUGHT_VIDEOS_REQUEST],
          () => payload.response,
        )
        .toJS();
    case FETCH_LAST_BOUGHT_VIDEOS_FAILURE:
      return Immutable.fromJS(state)
        .updateIn(
          ['failedRequests', FETCH_LAST_BOUGHT_VIDEOS_REQUEST],
          () => payload.error,
        )
        .toJS();
    case FETCH_VIDEOS_REQUEST:
      return Immutable.fromJS(state)
        .updateIn(['requests', FETCH_VIDEOS_REQUEST, 'pending'], () => true)
        .toJS();
    case FETCH_VIDEOS_SUCCESS:
      return Immutable.fromJS(state)
        .updateIn(
          ['successfulRequests', FETCH_VIDEOS_REQUEST],
          () => payload.response,
        )
        .updateIn(['requests', FETCH_VIDEOS_REQUEST, 'pending'], () => false)
        .toJS();
    case FETCH_VIDEOS_FAILURE:
      return Immutable.fromJS(state)
        .updateIn(['failedRequests', FETCH_VIDEOS_REQUEST], () => payload.error)
        .updateIn(['requests', FETCH_VIDEOS_REQUEST, 'pending'], () => false)
        .toJS();
    default:
      return state;
  }
};
